export default "__VITE_ASSET__21fc934e__"